import React from 'react';
import { Grid } from '@mui/material';
import clsx from 'clsx';
import { HideInfoTooltipProps } from './HideInfoTooltip.props';
import { classes, StyledGrid } from './HideInfoTooltip.styles';



const HideInfoTooltip = ({ hideTooltip, tooltipTitle }: HideInfoTooltipProps) => (
  <StyledGrid
    className={clsx(classes.container, {
      'hide-container': hideTooltip,
    })}>
    <Grid className={classes.tooltip}>{tooltipTitle}</Grid>
  </StyledGrid>
);

export default HideInfoTooltip;
